import { render, staticRenderFns } from "./CmgPaymentsAndGiftCardsPage.vue?vue&type=template&id=1ba1537b&scoped=true&lang=pug"
import script from "./cmg-payments-and-gift-cards-page.ts?vue&type=script&lang=ts&external"
export * from "./cmg-payments-and-gift-cards-page.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgPaymentsAndGiftCardsPage.vue?vue&type=style&index=0&id=1ba1537b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba1537b",
  null
  
)

export default component.exports